import { useContext, createContext } from 'react';

export const AppContext = createContext(null);
export const ApiContext = createContext(null);

export function useAppContext() {
  return useContext(AppContext);
}

export function useApiContext() {
  return useContext(ApiContext);
}
